import { list } from '../../../../../common/classes/request-builder';

export class FincasListsDefinition {
  public sectores = list();

  public parcelas = list();

  public variedades = list();

  /* lista de años por defecto */
  public year = list();

  public tipos = list(
    ['...', null],
    ['Agricultura Ecológica', 'AE'],
    ['Producción Integrada', 'PI'],
    ['Certificacion Privada', 'CP'],
    ['Agrupacion de Tratamiento Integrado en Agricultura', 'Atrias'],
    ['Asistida de un asesor', 'AS'],
    ['Sin obligacion de aplicar la GIP', 'NO']
  );
  
  public clientes = list();
  
  public productos = list();
  
  public propiedad = list(
    ['...', null],
    ['Propias', 'Propias'],
    ['Arrendadas', 'Arrendadas']
  );
}